export default __webpack_public_path__ + "static/media/O-055.88d60c6f.png";